import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import dimensions from "react-dimensions";
import Card, { CardHeader, CardContent, CardActions } from "material-ui/Card";
import Collapse from "material-ui/transitions/Collapse";

import Typography from "material-ui/Typography";
import CenteredProgress from "./CenteredProgress";

const styles = theme => ({
  root: {
    padding: 10,
    marginBottom: 20
  },
  headerContainer: {
    display: "flex",
    flexDirection: "row"
  },
  headerinfo: {
    flexGrow: 1
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  flexGrow: {
    flex: "1 1 auto"
  },
  hidden: {
    display: "none"
  }
});

class OvChartPanel extends Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
    this.handleExpandClick = this.handleExpandClick.bind(this);
  }

  handleExpandClick() {
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    const {
      classes,
      chartTitle,
      chartSubheader,
      chart,
      seriesLegend,

      chartActions,
      loading
    } = this.props;

    return (
      <Card className={classes.root}>
        <div className={classes.headerContainer}>
          <CardHeader
            className={classes.headerinfo}
            title={<Typography type="body2">{chartTitle}</Typography>}
            subheader={chartSubheader}
            action={chartActions}
          />
        </div>

        {loading ? <CenteredProgress /> : chart}

        <CardActions
          disableActionSpacing
          className={seriesLegend ? null : classes.hidden}
        >
          <div className={classes.flexGrow} />
          {seriesLegend}
        </CardActions>

        <Collapse
          in={this.state.expanded}
          unmountOnExit
        >
          <CardContent>
            <Typography paragraph type="body2">
              Analysis:
            </Typography>
          </CardContent>
        </Collapse>
      </Card>
    );
  }
}

OvChartPanel.propTypes = {
  chartTitle: PropTypes.string.isRequired,
  chartSubheader: PropTypes.string.isRequired,
  chart: PropTypes.element.isRequired,
  seriesLegend: PropTypes.element,
  chartActions: PropTypes.element,
  loading: PropTypes.bool
};

OvChartPanel.defaultProps = {
  loading: false
};

export { OvChartPanel };

export default withStyles(styles, { name: "OvChartPanel" })(
  dimensions({ elementResize: true })(OvChartPanel)
);



// WEBPACK FOOTER //
// ./src/OvChartPanel.js